import { envelopeSettings } from '@/services/BffHttp';

export default {
  namespaced: true,
  state: {
    lastVisibility: null,
  },
  getters: {
    getLastVisibility: (state) => state.lastVisibility,
  },
  actions: {
    getLastVisibility: ({ commit }) => {
      return envelopeSettings
        .getSettings()
        .then((res) => {
          const teamVisibility = res.data.last_envelope_visibility_team;
          commit('setLastVisibility', teamVisibility);
          return teamVisibility;
        })
        .catch(() => {
          commit('setLastVisibility', null);
          return null;
        });
    },
    saveLastVisibility: ({ commit }, visibility) => {
      return envelopeSettings
        .updateSettings({ last_envelope_visibility_team: visibility })
        .then(() => {
          commit('setLastVisibility', visibility);
        })
        .catch(() => {});
    },
  },
  mutations: {
    setLastVisibility: (state, visibility) => {
      state.lastVisibility = visibility;
    },
  },
};
